import { atom } from "recoil"

export const getOrderDetailIdRequestState = atom({
  key: "atoms/paidTeam/getOrderDetailIdRequestState",
  default: 0,
})
